import {
  CustomButton,
  CustomCheckbox,
  CustomForm,
  CustomFormItem,
  CustomImage,
  CustomModal,
  CustomSelect,
  Option,
  Text,
  useText,
} from '@src/components';
import modalClose from '@src/assets/icons/icon-close.svg';
import address from '@src/assets/images/cardOrders/address.svg';
import { useCallback, useEffect, useState } from 'react';
import { Form } from 'antd';
import '@src/styles/cardOrder/deliveryAddressChooseForm.scss';
import { useDispatch, useSelector } from 'react-redux';
import { addressGetPagedListByUserQuery } from '@src/store/slice/addressSlice';
import { setAllCardAddressCheckedData } from '@src/store/slice/cardOrderDetailtsSlice';
import { turkishToLower } from '@src/utils/utils';

const DeliveryAddressChooseForm = ({
  modalVisible,
  handleModalVisible,
  handleAddFormModalVisible,
  handleSelectedAddress,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { addressListByUserQuery } = useSelector((state) => state?.address);
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const [selectedAddressText, setSelectedAddressText] = useState('');
  const [selectedAddressDetail, setSelectedAddressDetail] = useState('');
  const { selectedRow } = useSelector((state) => state?.cardOrderDetails);
  useEffect(() => {
    if (modalVisible) {
      (async () => {
        if (addressListByUserQuery.length === 0) {
          await dispatch(
            addressGetPagedListByUserQuery({
              pageNumber: 0,
              pageSize: 0,
            }),
          );
        }
        form.setFieldsValue({
          addressValue: selectedRow?.addressId,
        });
        await setAddressDetail(selectedRow?.addressId);
      })();
    }
  }, [dispatch, modalVisible, selectedRow, form]);

  useEffect(() => {
    if (selectedCustomer) {
      dispatch(
        addressGetPagedListByUserQuery({
          pageNumber: 0,
          pageSize: 0,
          customerId: selectedCustomer?.customerId,
        }),
      );
    }
  }, [selectedCustomer, dispatch]);

  const onOk = useCallback(async () => {
    try {
      const values = await form.validateFields();
      handleSelectedAddress?.({ ...values, addressText: selectedAddressText });
      if (values.allCardAddressChecked) {
        dispatch(
          setAllCardAddressCheckedData({
            addressId: values?.addressValue,
            addressText: selectedAddressText,
          }),
        );
      }
      form.resetFields();
      setSelectedAddressDetail('');
    } catch (e) { }
  }, [dispatch, form, handleSelectedAddress, selectedAddressText]);

  const handleClose = useCallback(() => {
    handleModalVisible(false);
    form.resetFields();
    setSelectedAddressDetail('');
  }, [form, handleModalVisible]);

  const handleNewDeliveryAddressModal = useCallback(() => {
    handleClose();
    handleAddFormModalVisible(true);
  }, [handleAddFormModalVisible, handleClose]);

  const handleRefNoChange = (e, adressId) => {
    setSelectedAddressText(e);
    setAddressDetail(adressId);
  };

  const setAddressDetail = (adressId) => {
    addressListByUserQuery.forEach((item) => {
      if (adressId === item.id) {
        setSelectedAddressDetail(item.companyAddress);
      }
    });
  };

  return (
    <CustomModal
      className="delivery-address-add"
      width={810}
      maskClosable={false}
      footer={
        <div className={'footer-content'}>
          <span onClick={handleNewDeliveryAddressModal} className={'new-delivery-address-add'}>
            + <Text t="addNewDeliveryAddress" />
          </span>

          <div className={'cancel-ok-buttons-content'}>
            <span onClick={handleClose} className={'cancel-button'}>
              <Text t="giveUp" />
            </span>

            <CustomButton
              id="ticketRestaurant-cardOrders-cardInformation-deliveryAddressChooseForm-ok-button"
              type="primary"
              onClick={onOk}
              className={'ok-button'}
            >
              <Text t="okBtn" />
            </CustomButton>
          </div>
        </div>
      }
      title={<Text t="selectDeliveryAddress" />}
      visible={modalVisible}
      onCancel={handleClose}
      closeIcon={<CustomImage src={modalClose} />}
    >
      <div className="delivery-address-choose-text-content">
        <CustomImage src={address} />
        <span className="choose-form-text">
          <Text t={'selectRegisteredAddressOrDefineNew'} />
        </span>
      </div>

      <CustomForm
        name="deliveryAddressAddForm"
        initialValues={{
          allCardAddressChecked: false,
        }}
        autoComplete="off"
        layout={'vertical'}
        form={form}
      >
        <div className="row ">
          <div className="col-md-12">
            <CustomFormItem
              label={<Text t="registeredDeliveryAddresses" />}
              name="addressValue"
              className={'delivery-address-add-form-item'}
              rules={[{ required: true, message: <Text t="requiredField2" /> }]}
            >
              <CustomSelect
                id="ticketRestaurant-cardOrders-cardInformation-deliveryAddressChooseForm-addressValue-select"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  turkishToLower(option.children).includes(turkishToLower(input))
                }
                placeholder={useText('selectTheAddressWhereDeliveryWillBeMade')}
                onChange={(_, e) => {
                  handleRefNoChange(e?.children, e?.value);
                }}
              >
                <Option
                  id={`ticketRestaurant-cardOrders-cardInformation-deliveryAddressChooseForm-addressValue-choose-address-option`}
                  key={``}
                  value={''}
                >
                  <Text t="selectAddress3" />
                </Option>
                {addressListByUserQuery?.map((item, index) => (
                  <Option
                    id={`ticketRestaurant-cardOrders-cardInformation-deliveryAddressChooseForm-addressValue-${item?.addressName}-option`}
                    key={item?.id}
                    value={item?.id}
                  >
                    {item?.addressName}
                  </Option>
                ))}
              </CustomSelect>
            </CustomFormItem>
            {selectedAddressDetail && (
              <div className="detail-address-text">{selectedAddressDetail}</div>
            )}
          </div>

          <div className="col-md-12">
            <CustomFormItem
              label={false}
              name="allCardAddressChecked"
              className="delivery-address-form-item-check"
              valuePropName="checked"
            >
              <CustomCheckbox
                id="ticketRestaurant-cardOrders-cardInformation-deliveryAddressChooseForm-allCardAddressChecked-checkbox"
                className="all-card-use-check"
              >
                <Text t="useThisAddressForAllCardInformation" />
              </CustomCheckbox>
            </CustomFormItem>
          </div>
        </div>
      </CustomForm>
    </CustomModal>
  );
};

export default DeliveryAddressChooseForm;
